import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Styles from "../TestComponentStyles.module.css";
import { useTestStore } from "../../../hooks/store";
import { useSearchParams } from "react-router";
import { useEffect, useState } from "react";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import HighlightOffSharpIcon from "@mui/icons-material/HighlightOffSharp";
import { testType } from "../../../utils/testHelper";

export function TestQuestionList() {
  const testStore = useTestStore();
  const { questionList, userAnswers } = testStore;

  const [selectedQuestion, setSelectedQuestion] = useState(questionList[0].id);
  const [params, setParams] = useSearchParams();

  /*
  
    Бесполезно
  
  */
  // useEffect(() => {
  //   console.log(params);
  //   // !params.get("question") && params.set("question", questionList[0].id);
  //   setParams({ ...params, question: questionList[0].id });
  // }, []);

  useEffect(() => {
    // console.log(params);
    params.set("question", selectedQuestion);
    setParams(params);

    //params.set("question", selectedQuestion);
  }, [selectedQuestion]);

  const handleQuestionSelect = (id) => {
    setSelectedQuestion(id);
  };

  const listWidth =
    (testStore.testType.type == testType.marathon.type && {
      width: 0,
      border: "none",
    }) ||
    {};

  return (
    <div className={Styles.question_list} style={listWidth}>
      <List
        sx={{ overflow: "auto", maxHeight: "100%" }}
        id={"question_list"}
        dense>
        {questionList.map((item, index) => {
          const userAnswer =
            userAnswers.length &&
            userAnswers.find((answer) => {
              return answer.questionId == item.id;
            });

          const setQuestionStatus = () => {
            if (!userAnswer) {
              return <></>;
            } else if (
              userAnswer.questionId == item.id &&
              userAnswer.is_right &&
              testStore.testType.type !== testType.exam.type
            ) {
              return (
                <CheckCircleOutlineSharpIcon
                  sx={{ color: "var(--baze-correct)" }}
                />
              );
            } else if (
              userAnswer.questionId == item.id &&
              !userAnswer.is_right &&
              testStore.testType.type !== testType.exam.type
            ) {
              return (
                <HighlightOffSharpIcon sx={{ color: "var(--baze-wrong)" }} />
              );
              // } else if (userAnswer.userAnswer == item.id && ) {
            } else if (testStore.testType.type === testType.exam.type) {
              return <RadioButtonCheckedIcon />;
            }
          };

          const setQuestionStatusClass = () => {
            if (!userAnswer) {
              return <></>;
            } else if (
              userAnswer.questionId == item.id &&
              userAnswer.is_right &&
              testStore.testType.type !== testType.exam.type
            ) {
              return Styles.question_list_correct;
            } else if (
              userAnswer.questionId == item.id &&
              !userAnswer.is_right &&
              testStore.testType.type !== testType.exam.type
            ) {
              return Styles.question_list_wrong;
            } else {
              return Styles.question_answer_exam;
            }
          };
          return (
            <>
              <ListItem
                sx={{ cursor: "pointer", userSelect: "none" }}
                onClick={(e) => {
                  handleQuestionSelect(item.id);
                  e.target.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  });
                }}
                id={item.id}
                key={Math.random}
                className={`${Styles.question_list_item} ${
                  params.get("question") == item.id &&
                  Styles.question_list_active
                } ${setQuestionStatusClass()}`}>
                <ListItemIcon
                  className={`${Styles.question_list_icon} `}
                  style={{ minWidth: 20, color: " var(--bckg-accent)" }}>
                  {params.get("question") == item.id && (
                    <ArrowRightRoundedIcon fontSize="small" edge={"end"} />
                  )}
                </ListItemIcon>
                <ListItemText className={Styles.question_list_text}>
                  {window.innerWidth < 768
                    ? index + 1
                    : `
                  Вопрос ${index + 1}
                        `}
                </ListItemText>

                <ListItemIcon className={Styles.question_list_icon}>
                  {setQuestionStatus()}
                </ListItemIcon>
              </ListItem>
              <Divider
                variant="middle"
                style={{
                  color: "var(--bckg-baze)",
                  boxShadow: "none",
                  marginBlock: "0.5rem",
                }}
              />
            </>
          );
        })}
      </List>
    </div>
  );
}
